import { FC } from 'react';

import { ImagesApp } from '../../../constants/images';
import { useI18nContext } from '../../../hooks/contexts/i18n.context';
import { useUiContext } from '../../../hooks/contexts/ui.context';
import * as Styles from './styles.tagNaming';

type TagNamingProps = {
  transferMandatoryFaceRecognition: boolean;
  faceRecognition: boolean;
};

const TagNaming: FC<TagNamingProps> = ({ faceRecognition, transferMandatoryFaceRecognition }) => {
  const { translate } = useI18nContext();
  const { isMobile } = useUiContext();

  const messageTag = faceRecognition && !transferMandatoryFaceRecognition
    ? translate(['INFORMATION', 'ACCESS_BY_QRCODE_OR_FACE'])
    : transferMandatoryFaceRecognition ? translate(['INFORMATION', 'ACCESS_BY_FACE'])
      : !transferMandatoryFaceRecognition && !faceRecognition ? translate(['INFORMATION', 'ACCESS_BY_QRCODE']) : '';

  return (
    <Styles.WrapperTag id="tag-naming-wrapper">
      <Styles.ImageTag src={ImagesApp.svg.faceNaming} alt="Face" id="tag-naming-image" />
      { isMobile || (
        <Styles.TextTag id="tag-naming-text">
          {messageTag}
        </Styles.TextTag>
      )}
    </Styles.WrapperTag>
  );
};

export default TagNaming;
